/* EditPromptHoverTag.tsx generated by @compiled/babel-plugin v0.36.1 */
/** @jsxFrag */
import "./EditPromptHoverTag.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { SimpleTag } from '@atlaskit/tag';
import { messages } from './messages';

/**
 * The opacity of this button is controlled by the parent component
 */
var containerStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var containerStylesUnbounded = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var placeholderStyles = null;
export var EditPromptHoverTag = function EditPromptHoverTag(_ref) {
  var _ref$isClearMode = _ref.isClearMode,
    isClearMode = _ref$isClearMode === void 0 ? false : _ref$isClearMode,
    isPlaceholder = _ref.isPlaceholder;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var text = React.useMemo(function () {
    return isClearMode ? formatMessage(messages.clearPromptHover) : formatMessage(messages.editPromptHover);
  }, [isClearMode, formatMessage]);
  return /*#__PURE__*/React.createElement("span", {
    id: "edit-prompt-hover-button",
    "data-testid": "edit-prompt-hover-button",
    className: ax(["_1o9zidpf _18u01wug _19pk1i6y _otyr1i6y _1e0c116y _tzy4idpf", "_1npcidpf _1gicidpf _1e09idpf _1mspidpf _1vf2tlke _1at8v77o _1cjov77o _1yg612x7 _hjaq12x7", isPlaceholder && "_1vf273ad"])
  }, /*#__PURE__*/React.createElement(SimpleTag, {
    text: text
  }));
};